import React from 'react';
import { GridOverlay } from '@mui/x-data-grid-pro';
import { ReactComponent as EmptyTruckIcon } from 'assets/icons/empty-truck.svg';

export const NoneDeletedOverlay: React.FC = () => {
  return (
    <GridOverlay className="pt-8">
      <div className="flex flex-col p-4 space-y-4 items-center" style={{ zIndex: 1099 }}>
        <EmptyTruckIcon />
        <div className="flex flex-col items-center">
          <h3 className="text-dark">No deleted containers.</h3>
        </div>
      </div>
    </GridOverlay>
  );
};
NoneDeletedOverlay.displayName = 'ContainerTable.NoneDeletedOverlay';
